document.addEventListener('DOMContentLoaded', () => {
    let isSearchModalOpen = false;
    let predictiveSearch = null;
    let defaultSearchContent = '';
    let searchModalResults = null;
    let searchModalContent = null;

    function restoreDefaultContent() {
        if (!(searchModalResults && defaultSearchContent)) {
            return;
        }
        searchModalResults.innerHTML = defaultSearchContent;
        searchModalResults.classList.remove('hidden', 'invisible', 'opacity-0');
        searchModalResults.classList.add('block', 'visible', 'opacity-100');
        searchModalResults.removeAttribute('style');
        searchModalResults.removeAttribute('aria-hidden');

        const productCards = searchModalResults.querySelectorAll('.product-card[data-product-id]');
        productCards.forEach(card => {
            card.removeAttribute('data-variants-initialized');
            const swatches = card.querySelectorAll('.color-swatch[data-variant-id]');
            swatches.forEach(swatch => {
                swatch.removeAttribute('data-variant-listener-added');
            });
        });
    }

    function openSearchModal() {
        const searchModal = document.getElementById('search-modal');
        const searchModalInput = document.getElementById('search-modal-input');
        if (!searchModal || !searchModalInput || isSearchModalOpen) return;

        isSearchModalOpen = true;

        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.classList.add('overflow-hidden');

        const searchTriggers = document.querySelectorAll('.search-trigger');
        searchTriggers.forEach(trigger => {
            trigger.setAttribute('aria-expanded', 'true');
        });

        requestAnimationFrame(() => {
            searchModal.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
            searchModal.classList.add('opacity-100', 'visible');
            searchModal.setAttribute('aria-hidden', 'false');
            searchModal.removeAttribute('inert');

            requestAnimationFrame(() => {
                restoreDefaultContent();

                if (searchModalResults) {
                    searchModalResults.removeAttribute('style');
                    searchModalResults.classList.remove('hidden', 'invisible', 'opacity-0');
                    searchModalResults.classList.add('block', 'visible', 'opacity-100');
                    searchModalResults.removeAttribute('aria-hidden');
                    searchModalResults.setAttribute('aria-hidden', 'false');
                }

                if (window.searchHistory && typeof window.searchHistory.showDefaultContent === 'function') {
                    window.searchHistory.showDefaultContent();
                }

                setTimeout(() => {
                    if (typeof window.initializeProductCardVariants === 'function') {
                        window.initializeProductCardVariants(searchModalResults);
                    }
                }, 100);
            });

            setTimeout(() => {
                searchModalInput.focus();
            }, 350);
        });
    }

    function closeSearchModal() {
        const searchModal = document.getElementById('search-modal');
        const searchModalInput = document.getElementById('search-modal-input');
        if (!searchModal || !searchModalInput || !isSearchModalOpen) return;

        isSearchModalOpen = false;

        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.classList.remove('overflow-hidden');

        if (scrollY) {
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        const searchTriggers = document.querySelectorAll('.search-trigger');
        searchTriggers.forEach(trigger => {
            trigger.setAttribute('aria-expanded', 'false');
        });

        searchModal.classList.add('opacity-0', 'invisible', 'pointer-events-none');
        searchModal.classList.remove('opacity-100', 'visible');
        searchModal.setAttribute('aria-hidden', 'true');
        searchModal.setAttribute('inert', '');
        searchModalInput.value = '';

        if (predictiveSearch) {
            predictiveSearch.close();
        }

        setTimeout(() => {
            restoreDefaultContent();
        }, 300);
    }

    const searchTriggers = document.querySelectorAll('.search-trigger');
    const searchModal = document.getElementById('search-modal');
    const searchModalInput = document.getElementById('search-modal-input');
    const searchModalClose = document.getElementById('search-modal-close');
    searchModalResults = document.getElementById('search-modal-results');
    searchModalContent = searchModal?.querySelector('.search-modal-content');

    const hasSearchModal = searchModal && searchModalInput && searchModalClose && searchModalResults && searchModalContent;

    if (!hasSearchModal) {
        return;
    }

    if (searchModalResults) {
        defaultSearchContent = searchModalResults.innerHTML;
    }

    searchTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            openSearchModal();
        });
    });

    searchModalClose.addEventListener('click', (e) => {
        e.stopPropagation();
        closeSearchModal();
    });

    searchModal.addEventListener('click', (e) => {
        if (searchModalContent && !searchModalContent.contains(e.target)) {
            closeSearchModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isSearchModalOpen) {
            closeSearchModal();
        }
    });

    function isMobileViewport() {
        return window.matchMedia('(max-width: 1023px)').matches;
    }

    if (searchModalResults && searchModalInput) {
        searchModalResults.addEventListener('scroll', () => {
            if (isSearchModalOpen && isMobileViewport() && document.activeElement === searchModalInput) {
                searchModalInput.blur();
            }
        }, { passive: true });
    }

    if (typeof PredictiveSearch !== 'undefined') {
        if (searchModalResults) {
            searchModalResults.classList.remove('hidden', 'invisible', 'opacity-0');
            searchModalResults.classList.add('block', 'visible', 'opacity-100');
        }

        predictiveSearch = new PredictiveSearch(searchModalInput, searchModalResults, {
            debounceTime: 200,
            minQueryLength: 1,
            sectionId: 'predictive-search',
            resources: {
                type: 'query,product,collection,page,article',
                limit: 10,
                options: {
                    unavailable_products: 'hide',
                    fields: 'title,product_type,variants.title,vendor'
                }
            },
            onOpen: () => {
                if (!searchModalResults) {
                    return;
                }
                searchModalResults.classList.remove('hidden', 'invisible', 'opacity-0');
                searchModalResults.classList.add('block', 'visible', 'opacity-100');
                searchModalResults.removeAttribute('aria-hidden');
                searchModalResults.setAttribute('aria-hidden', 'false');
            },
            onClose: () => {
                return;
            }
        });
    }
});

